import ArticleLayout from '@/components/feature/ArticleLayout';
import { oopbuyArticle } from '@/mocks/article-data';
import ArticleSchema from '@/components/feature/ArticleSchema';

export default function OopbuyArticle() {
  return (
    <>
      <ArticleSchema
        slug="oopbuy-spreadsheet-guide"
        title="Oopbuy Spreadsheet Complete Guide 2026"
        description="Complete Oopbuy Spreadsheet guide focused on budget-friendly shopping strategies. Compare Oopbuy Spreadsheet with Hipobuy, Kakobuy, CSSBuy, and Superbuy platforms for the best value shopping experience."
        imageUrl="https://readdy.ai/api/search-image?query=Smart%20shopping%20and%20budget%20planning%20theme%20with%20calculator%20notepad%20price%20tags%20and%20folded%20receipts%20arranged%20on%20light%20wood%20grain%20surface%2C%20bright%20clean%20natural%20lighting%2C%20organized%20personal%20finance%20aesthetic%2C%20mint%20green%20cream%20and%20warm%20wood%20tones%2C%20practical%20lifestyle%20editorial%2C%20fresh%20approachable%20atmosphere&width=1920&height=800&seq=article-oopbuy-hero-v2&orientation=landscape"
      />
      <ArticleLayout article={oopbuyArticle} />
    </>
  );
}